export const useTranslateOptions = (options, translation) => {
  if (Array.isArray(options)) {
    return options.map((option) => ({
      ...option,
      label: translation[option.translation]
    }));
  }
};
